const style = {
  formWrapper: {
    maxWidth: "80%",
  },

  formSectionWrapper: {
    width: 750,
    // paddingLeft: theme.spacing(10),
    // marginTop: (props) => (props.showAll ? theme.spacing(10) : 0),
  },
  box: {
    height: 230,
    border: `1px solid gray`,
  },
  options: {
    margin: "8px",
    width: "100%",
  },
  chipIconWrapper: {
    height: 10,
    // background: theme.palette.common.white,
    borderRadius: 7,
    padding: 2,
    width: 10,
    marginLeft: 3,
    background: "white",
  },
  chipIcon: {
    height: 8,
    position: "relative",
    top: -10,
    left: -1,
  },
  snippetsWrapper: { marging: "8px", width: "100%" },
  input: {
    width: 300,
  },
  phoneList: {
    maxHeight: 300,
    maxWidth: 300,
    overflowWrap: "break-work",
  },
  phoneListItem: {
    whiteSpace: "normal",
  },
  webhookHeadersWrapper: {
    maxHeight: 156,
    overflow: "auto",
  },
  extensionInput: {
    width: "350px !important",
  },
  webhookDialogPaper: {
    width: "60%",
    minWidth: "832px",
  },
  showInputSwitch: {
    color: "#000",
  },
};

export default style;
